export function init(): void {
	import('./view')
		.then(mod => (new mod.PriceCreateView()));
}
